var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.03V100.16H120.81V102.19C81.22 108.96 67 131.29 67 169.19H101.86C101.86 125.87 130.62 102.86 169.2 100.16V69.03H48.39V67C87.98 60.23 102.2 37.9 102.2 0H67.34C67.34 43.32 38.58 66.33 0 69.03Z",
    fill: "#FF684A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrLogo);
export default __webpack_public_path__ + "static/media/qr-logo.cdbde75d7151723ea3da0a3461e52f7b.svg";
export { ForwardRef as ReactComponent };